const btnExpiredServices = {
  label: 'filtros',
  Typography: 'Nenhum resultado encontrado'
};

export default btnExpiredServices;
